@import '../../../globals/main.scss';

pn-product-tile {
  margin-bottom: 1em;
  border: 0.1rem solid $gray200;
  outline: none;
  background: white;
  box-shadow:
    0px 0.6px 1.8px rgba(0, 0, 0, 0.1),
    0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
  display: flex;

  padding: 1.5em;
  word-break: break-word;
  text-decoration: none;
  border-radius: 0.8rem;

  [slot='content'] h3 {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 0.5em;
  }
  > pn-illustration {
    min-width: 8rem;
    width: 8rem;
    height: 8rem;
    margin-right: 3rem;
    align-self: center;
  }
  .tilecontent {
    display: flex;
    // flex-wrap: wrap;
    flex-direction: row;
    //align-items: flex-start;
    justify-content: center;
    flex-grow: 1;
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    //align-items: center;
  }
  .info {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    max-width: calc((100% / 3) * 2);
    flex-flow: wrap;
    > * {
      min-width: 6em;
      margin: 0.2em 1em 0.2em 0;
    }
  }
}
